import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onsitetraining',
  templateUrl: './onsitetraining.component.html',
  styleUrls: ['./onsitetraining.component.css']
})
export class OnsitetrainingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
